import moment from 'moment';
import { Modal, Stack } from 'react-bootstrap';
import { TIMEZONES, UTC_TIMEZONE_VALUE } from '../constants/tz';
import CreativesForm from './CreativesForm';
import { CAMPAIGN_DEMAND_SOURCES } from '../constants/campaign';
import { getDemandSourceLabel } from '../utils/demandSource';

const DetailModal = ({ detailsShow, closeDetails, campaign }) => {
  const [automatic, manual] = [campaign.automatic, !campaign.automatic];

  const timezoneLabel = campaign.tzOffset
    ? TIMEZONES.find((tz) => tz.value === campaign.tzOffset)?.label
    : UTC_TIMEZONE_VALUE;

  const fields = [
    {
      label: 'Campaign Creatives',
      value: <CreativesForm campaignId={campaign._id} />,
      isHidden: automatic,
    },
    {
      label: 'Campaign ID',
      value: campaign._id,
    },
    {
      label: 'Campaign Name',
      value: campaign.campaignName,
    },
    {
      label: 'Status',
      value: campaign.detailedStatus,
    },
    {
      label: 'Industry',
      value: campaign.industry,
    },
    {
      label: 'Country',
      value: campaign.country,
    },
    {
      label: 'Responses/Views',
      value: `${campaign.submitCount}/${campaign.viewCount}`,
    },
    {
      label: 'Responses/Views (Control)',
      value: `${campaign.controlSubmit}/${campaign.controlView}`,
    },
    {
      label: 'Responses/Views (Exposed)',
      value: `${campaign.exposedSubmit}/${campaign.exposedView}`,
    },
    {
      label: 'Opportunity ID',
      value: campaign.opportunityId,
    },
    {
      label: 'Total Responses Per Group',
      value: campaign.targetNumberOfResponses,
      isHidden: manual,
    },
    {
      label: 'Total Impressions Per Group',
      value: campaign.targetNumberOfSurveyImpressions,
      isHidden: manual,
    },
    {
      label: 'Campaign Demand Source',
      value: getDemandSourceLabel(campaign.campaignDemandSource),
      isHidden: manual,
    },
    {
      label: 'Target Campaign/Deal IDs (comma separated)',
      value: campaign.campaignDemandSource === CAMPAIGN_DEMAND_SOURCES.PMP ? campaign.dealIds?.join(', ') : campaign.campaignIds?.join(', '),
      isHidden: manual,
    },
    {
      label: 'Exposed Bid Rate ($ CPM)',
      value: campaign.exposedCpmBid,
      isHidden: manual,
    },
    {
      label: 'Control Bid Rate ($ CPM)',
      value: campaign.controlCpmBid,
      isHidden: manual,
    },
    {
      label: 'Start Date',
      value: `${moment(campaign.campaignStart).format('ll')}`,
    },
    {
      label: 'End Date',
      value: `${moment(campaign.campaignEnd).format('ll')}`,
    },
    {
      label: 'Time Zone',
      value: timezoneLabel,
    },
    {
      label: 'First Impression Date',
      value: `${
        campaign.firstImpressionDate ? moment(campaign.firstImpressionDate).format('ll') : '-'
      }`,
    },
    {
      label: 'Details',
      value: campaign.campaignDetails,
    },
  ].filter(({ value, isHidden }) => !isHidden && !!value);

  return (
    <Modal show={detailsShow} onHide={closeDetails} backdrop="static" keyboard={false}>
      <Modal.Header closeButton closeLabel="" style={{ borderRadius: 5 }}>
        <Modal.Title>Campaign Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Stack gap={3}>
          {fields.map(({ label, value }) => (
            <div key={label}>
              <div>
                <b>{label}</b>
              </div>
              {value}
            </div>
          ))}
        </Stack>
      </Modal.Body>
    </Modal>
  );
};

export default DetailModal;
